import { Injectable, Pipe, PipeTransform, inject } from '@angular/core';
import { Rect } from '../../classes/rect.class';
import { specialCaseFormats } from '../../consts';
import { calcBaseUrlFromUuid } from '../../lib/calc-base-url';
import { calcResizedUrlFromUuid } from '../../lib/calc-resized-url';
import { PICFLOW_CONFIG } from '../../picflow-config';
import { AssetVersionUrlPipe } from './asset-version-url.pipe';

@Pipe({
  name: 'galleryCoverUrl',
  // pure: false,
  standalone: true,
})
@Injectable({
  providedIn: 'root',
})
export class GalleryCoverUrlPipe implements PipeTransform {
  private assetVersionUrl = inject(AssetVersionUrlPipe);
  private config = inject(PICFLOW_CONFIG);

  transform(
    uuid: string,
    coverWidth: number,
    coverHeight: number,
    targetWidth: number,
    targetHeight: number,
    coverExtension: string
  ): string {
    if (!targetWidth) targetWidth = 500; // ssr sometimes needs this
    if (!targetHeight) targetHeight = 500; // ssr sometimes needs this
    if (!uuid) return '';
    const aspectRatio = targetHeight / targetWidth;
    const coverAspectRatio = coverHeight / coverWidth;

    const diff = aspectRatio - coverAspectRatio;

    if (diff > 0) {
      targetWidth *= diff + 1;
    }

    const canUseSpecialVersion = specialCaseFormats.includes(coverExtension);
    const extension = canUseSpecialVersion ? 'webp' : 'jpg';

    const { width, height } = this.assetVersionUrl.getTargetDimensions(
      uuid,
      new Rect(0, 0, targetWidth, targetHeight),
      new Rect(0, 0, coverWidth, coverHeight)
    );

    if (!uuid) return '';
    uuid = uuid.split('|')[0];

    if (this.assetVersionUrl.shouldUseBase(coverWidth, width)) {
      return calcBaseUrlFromUuid(this.config.assetsEndpoint, uuid, extension);
    }

    const resizedUrl = calcResizedUrlFromUuid(
      this.config.assetsEndpoint,
      uuid,
      `l${Math.max(width, height)}`,
      canUseSpecialVersion
    );
    return resizedUrl;
  }
}
